import { merge } from 'lodash';

import type { BetSlipState, PersistedBetSlipState } from '../types';

const betSlipRehydrated = (
  state: BetSlipState,
  persistedState?: PersistedBetSlipState
): BetSlipState => merge({}, state, persistedState ?? {}, { rehydrated: true });

export default betSlipRehydrated;
